
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import Puzzle from "../../modules/puzzle/Puzzle";
import { puzzleApi } from "../../services/api";
function getParamValue(value: string | string[] | undefined) {
    return Array.isArray(value) ? value[0] : value;
}
export default function PuzzleDetailPage() {
    const router = useRouter();
    const id = useMemo(() => getParamValue(router.query.id as string | string[] | undefined), [router.query.id]);
    const [puzzles, setPuzzles] = useState<unknown[] | null>(null);
    const [nextPuzzleId, setNextPuzzleId] = useState(6497);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        if (!router.isReady || !id)
            return;
        let cancelled = false;
        setPuzzles(null);
        setFailed(false);
        puzzleApi
            .get("/puzzles/" + id)
            .then((response) => {
            if (cancelled)
                return;
            const loadedPuzzles = response?.data?.puzzles;
            if (!Array.isArray(loadedPuzzles) || loadedPuzzles.length === 0) {
                setFailed(true);
                return;
            }
            const randomPuzzleId = Number(response?.data?.nextPuzzleId);
            setNextPuzzleId(Number.isFinite(randomPuzzleId) ? randomPuzzleId : 6497);
            setPuzzles(loadedPuzzles);
        })
            .catch((error) => {
            if (cancelled)
                return;
            console.error("Error in puzzles", id, error);
            setFailed(true);
        });
        return () => {
            cancelled = true;
        };
    }, [id, router.isReady]);
    if (failed) {
        return <div className="flex justify-center p-8">Puzzle not found</div>;
    }
    if (!puzzles) {
        return <div className="flex justify-center p-8">Loading...</div>;
    }
    return (<Puzzle key={id} puzzles={puzzles} nextPuzzleId={nextPuzzleId} index={false}/>);
}

    async function __Next_Translate__getStaticProps__1a042aa3be0__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzle/view',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3be0__ as getStaticProps }
  